// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ckza","left":"styles_left__3JSei"};